import { render, staticRenderFns } from "./Campagna.vue?vue&type=template&id=0b5d8dec&"
import script from "./Campagna.vue?vue&type=script&lang=js&"
export * from "./Campagna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports